import { Component, OnInit } from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';
import {FormBuilder} from '@angular/forms';

import { AuthenicationService } from '../../_services/authenication.service';
import { VentoutwallService } from '../../_services/ventoutwall.service';
import { ToasterService } from '../../_services/toaster.service';

import {environment} from '../../../environments/environment';


declare var $: any;

@Component({
  selector: 'app-walllist',
  templateUrl: './walllist.component.html',
  styleUrls: ['./walllist.component.css']
})
export class WalllistComponent implements OnInit {


  discussionlist: [];
  userdetaild: string;
  returnUrl: string;
  baseUrl: string = environment.baseUrl;
  page = 1;
  size = 10;
  count = 0;
  totalS: any;
  searchValue = '';

  constructor(private formBuilder: FormBuilder, private authenicationService: AuthenicationService, private router: Router, private route: ActivatedRoute, private ventoutwallservice: VentoutwallService, private toaster: ToasterService) { }

  ngOnInit() {
    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }
    if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee2') {
      this.router.navigate(['/']);
    }

    const payload = {
      search: this.searchValue,
    };
    this.changeParam(payload);

    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';
  }

  changeParam(payload){
    this.ventOutWallList(this.page,this.size,payload);
  }

  ventOutWallList(page, size, payload) {
    this.ventoutwallservice.getVentOutWallList(page, size, payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            // this.toaster.showSuccess('Add Doctor', data.ResponseMessage);
            this.discussionlist = data.DiscussionList;
            this.count = data.total;
            this.createRange(data.total);
          } else {
            this.toaster.showError('Vents', data.ResponseMessage);
            this.discussionlist = [];
            this.count = 0;
            this.createRange(0);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('Categories', error.error.ResponseMessage);
          this.createRange(0);
          this.count = 0;
          this.discussionlist = [];
        });
  }

  createRange(number) {
    this.totalS = [];
    const num = (number / this.size);
    for (let i = 1; i <= Math.ceil(num); i++) {
      this.totalS.push(i);
    }
    return this.totalS;
  
  }

  pageChanged(event){
    this.page = event;
    const payload = {
      search: this.searchValue
    };
  
    this.ventOutWallList(this.page, this.size, payload);
  }
  
  Sort(event){
      
    this.size = event.target.value;
    const payload = {
      search: this.searchValue
    };
  
    this.ventOutWallList(this.page, this.size, payload);
  }
  
  search(event){
      
      // let strLeng = event.target.value.length;
  
      this.searchValue = event.target.value;
        const payload = {
          search: event.target.value
        };
  
        this.ventOutWallList(this.page, this.size, payload);
  }

  // deleteVentOutWall(id){
  //   this.ventoutwallservice.deleteVentOutWall(id)
  //     .subscribe(
  //       (data: any) => {
  //         if (data && data.ResponseCode === '200') {
  //            //this.toaster.showSuccess('MindPeers', data.ResponseMessage);
  //            this.ventOutWallList();
  //         } else {
  //           this.toaster.showError('MindPeers', data.ResponseMessage);
  //         }
  //         // this.router.navigate([this.returnUrl]);
  //       },
  //       error => {
  //         this.toaster.showError('MindPeers', error.error.ResponseMessage);
  //       });
  // }

  updateVent(updateObj){
    this.ventoutwallservice.updateVent(updateObj)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.toaster.showSuccess('Status Changed', data.ResponseMessage);
            // this.reloadComponent();
             //this.toaster.showSuccess('MindPeers', data.ResponseMessage);
             const payload = {
              search: this.searchValue
            };
             this.ventOutWallList(this.page, this.size, payload);
          } else {
            this.toaster.showError('MindPeers', data.ResponseMessage);
            const payload = {
              search: this.searchValue
            };
             this.ventOutWallList(this.page, this.size, payload);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('MindPeers', error.error.ResponseMessage);
        });
  }


}
